import { Link } from "react-router-dom";
import ExploreJumbotron from "./ExploreJumbotron";

export default function Footer() {
  return (
    <footer
      className="text-light position-relative"
      style={{ background: "rgb(23,27,42)" }}
    >
      <div className="container pb-5">
        <div className="position-relative" style={{ bottom: "70px" }}>
          <ExploreJumbotron />
        </div>

        <div className="row text-center text-md-start">
          <div className="col-md-4">
            <p className="lh-lg">
              We are committed to guiding our clients through every step of the
              buying, selling, or leasing process with professionalism and
              integrity.
            </p>
            <ul className="list-unstyled lh-lg">
              <li className="d-flex gap-3 justify-content-center justify-content-md-start">
                <i className="bi bi-geo-alt"></i>
                <a
                  href="https://maps.app.goo.gl/dtzU7ZViSnRfMwoRA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  5/429 High Street, Penrith, NSW 2750
                </a>
              </li>

              <li className="d-flex gap-3 justify-content-center justify-content-md-start">
                <i className="bi bi-telephone"></i>
                <a
                  href="tel:0424955982"
                  className="text-white text-decoration-none"
                >
                  0424 955 982
                </a>
              </li>

              <li className="d-flex gap-3 justify-content-center justify-content-md-start">
                <i className="bi bi-envelope"></i>
                <a
                  href="mailto:urbanview@urbanviewre.com"
                  className="text-white text-decoration-none"
                >
                  urbanview@urbanviewre.com
                </a>
              </li>
            </ul>

            <div className="d-flex gap-3 pt-3 justify-content-center justify-content-md-start">
              <a
                href="https://www.facebook.com/profile.php?id=61559035348971"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white rounded-circle"
                aria-label="Visit Urban View Real Estate on Facebook"
                style={{
                  background: "rgba(255,255,255,0.2)",
                  padding: "7px 11px",
                }}
              >
                <i className="bi bi-facebook fs-5" aria-hidden="true"></i>
              </a>

              <a
                href="https://www.instagram.com/urbanviewrealestate/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white rounded-circle"
                aria-label="Visit Urban View Real Estate on Instagram"
                style={{
                  background: "rgba(255,255,255,0.2)",
                  padding: "7px 11px",
                }}
              >
                <i className="bi bi-instagram fs-5" aria-hidden="true"></i>
              </a>

              <a
                href="https://www.linkedin.com/company/urbanviewrealestate/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white rounded-circle"
                aria-label="Visit Urban View Real Estate on LinkedIn"
                style={{
                  background: "rgba(255,255,255,0.2)",
                  padding: "7px 11px",
                }}
              >
                <i className="bi bi-linkedin fs-5" aria-hidden="true"></i>
              </a>

              <a
                href="https://www.youtube.com/@urbanviewrealestate"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white rounded-circle"
                aria-label="Visit Urban View Real Estate on YouTube"
                style={{
                  background: "rgba(255,255,255,0.2)",
                  padding: "7px 11px",
                }}
              >
                <i className="bi bi-youtube fs-5" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="col-md-2 mt-4 mt-md-0">
            <h5 className="brand">Company</h5>
            <ul className="list-unstyled lh-lg">
              <li>
                <Link className="text-light text-decoration-none" to="/about">
                  About
                </Link>
              </li>
              <li>
                <Link className="text-light text-decoration-none" to="/blog">
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  className="text-light text-decoration-none"
                  to="/properties"
                >
                  All Properties
                </Link>
              </li>
              <li>
                <Link className="text-light text-decoration-none" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-2 mt-4 mt-md-0">
            <h5 className="brand">Services</h5>
            <ul className="list-unstyled lh-lg">
              <li>
                <Link className="text-light text-decoration-none" to="/">
                  Buy Property
                </Link>
              </li>
              <li>
                <Link className="text-light text-decoration-none" to="/">
                  Sell Property
                </Link>
              </li>
              <li>
                <Link className="text-light text-decoration-none" to="/">
                  Manage Property
                </Link>
              </li>
              <li>
                <Link className="text-light text-decoration-none" to="/">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-4 mt-4 mt-md-0">
            <h5 className="brand">Newsletter</h5>
            <p className="m-0 py-3">
              Subscribe to our weekly Newsletter and receive updates via email.
            </p>
            <form className="d-flex">
              <input
                type="email"
                className="form-control rounded-0 py-3"
                placeholder="Email"
              />
              <button
                type="submit"
                className="btn rounded-0 text-white p-3"
                style={{ background: "#00b0f7" }}
                aria-label="Submit message"
              >
                <i className="bi bi-send-fill" aria-hidden="true"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="py-4" style={{ background: "rgb(40,43,56)" }}>
        <div className="container">
          <div className="row align-items-center text-center text-md-start">
            <div className="col-md-6">
              <p className="m-0">
                Copyright © {new Date().getFullYear()} UrbanView Real Estate.
                All Rights Reserved. (ABN: 58673884494)
              </p>

              <p className="small m-0">
                Web solution by{" "}
                <a
                  href="https://adada.com.au"
                  target="_blank"
                  className="text-decoration-none text-light"
                >
                  {" "}
                  ADADA Digital
                </a>
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
              <Link
                className="text-light text-decoration-none me-3"
                to="/terms-and-conditions"
              >
                Terms & Conditions
              </Link>
              <Link
                className="text-light text-decoration-none"
                to="/privacy-policy"
              >
                Privacy & Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
